export default __webpack_public_path__ + "static/media/instant_message_image.88080b68.png";